import axios from 'axios';

const useLive = false;

export const liveApiUrl = 'https://api.real-fake.news';
export const apiUrl =
  import.meta.env.DEV && !useLive ? 'http://localhost:80' : liveApiUrl;

export const axiosInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Function to set the auth token for requests
export function setAuthToken(token: string | null) {
  if (token) {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axiosInstance.defaults.headers.common['Authorization'];
  }
}

export default axiosInstance;
